/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConclusionGroupFull } from './ConclusionGroupFull';
import {
    ConclusionGroupFullFromJSON,
    ConclusionGroupFullFromJSONTyped,
    ConclusionGroupFullToJSON,
    ConclusionGroupFullToJSONTyped,
} from './ConclusionGroupFull';
import type { HealthProConsultation } from './HealthProConsultation';
import {
    HealthProConsultationFromJSON,
    HealthProConsultationFromJSONTyped,
    HealthProConsultationToJSON,
    HealthProConsultationToJSONTyped,
} from './HealthProConsultation';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';
import type { InstituteWithRole } from './InstituteWithRole';
import {
    InstituteWithRoleFromJSON,
    InstituteWithRoleFromJSONTyped,
    InstituteWithRoleToJSON,
    InstituteWithRoleToJSONTyped,
} from './InstituteWithRole';

/**
 * A fully resolved PatientEntryRelation (consultation)
 * @export
 * @interface Consultation
 */
export interface Consultation {
    /**
     * 
     * @type {string}
     * @memberof Consultation
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof Consultation
     */
    entryStart: string;
    /**
     * 
     * @type {boolean}
     * @memberof Consultation
     */
    isCreatedByService: boolean;
    /**
     * Computed from the current user's access rights
     * @type {boolean}
     * @memberof Consultation
     */
    isEditable: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Consultation
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Consultation
     */
    updated?: Date;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof Consultation
     */
    id: UiIdentifier;
    /**
     * 
     * @type {HealthProConsultation}
     * @memberof Consultation
     */
    healthPro?: HealthProConsultation;
    /**
     * 
     * @type {HealthProConsultation}
     * @memberof Consultation
     */
    secondaryHealthPro?: HealthProConsultation;
    /**
     * 
     * @type {InstituteWithRole}
     * @memberof Consultation
     */
    instituteWithRole?: InstituteWithRole;
    /**
     * Ordered conclusion groups (minusOneCcl filtered and appended last)
     * @type {Array<ConclusionGroupFull>}
     * @memberof Consultation
     */
    conclusionGroups: Array<ConclusionGroupFull>;
    /**
     * Total row count consumed by this entry in the CsList grid
     * @type {number}
     * @memberof Consultation
     */
    rows: number;
    /**
     * 
     * @type {HealthProConsultation}
     * @memberof Consultation
     */
    archivedByUser?: HealthProConsultation;
    /**
     * 
     * @type {string}
     * @memberof Consultation
     */
    archivedDate?: string;
}

/**
 * Check if a given object implements the Consultation interface.
 */
export function instanceOfConsultation(value: object): value is Consultation {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('entryStart' in value) || value['entryStart'] === undefined) return false;
    if (!('isCreatedByService' in value) || value['isCreatedByService'] === undefined) return false;
    if (!('isEditable' in value) || value['isEditable'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conclusionGroups' in value) || value['conclusionGroups'] === undefined) return false;
    if (!('rows' in value) || value['rows'] === undefined) return false;
    return true;
}

export function ConsultationFromJSON(json: any): Consultation {
    return ConsultationFromJSONTyped(json, false);
}

export function ConsultationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Consultation {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'entryStart': json['entryStart'],
        'isCreatedByService': json['isCreatedByService'],
        'isEditable': json['isEditable'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'id': UiIdentifierFromJSON(json['id']),
        'healthPro': json['healthPro'] == null ? undefined : HealthProConsultationFromJSON(json['healthPro']),
        'secondaryHealthPro': json['secondaryHealthPro'] == null ? undefined : HealthProConsultationFromJSON(json['secondaryHealthPro']),
        'instituteWithRole': json['instituteWithRole'] == null ? undefined : InstituteWithRoleFromJSON(json['instituteWithRole']),
        'conclusionGroups': ((json['conclusionGroups'] as Array<any>).map(ConclusionGroupFullFromJSON)),
        'rows': json['rows'],
        'archivedByUser': json['archivedByUser'] == null ? undefined : HealthProConsultationFromJSON(json['archivedByUser']),
        'archivedDate': json['archivedDate'] == null ? undefined : json['archivedDate'],
    };
}

export function ConsultationToJSON(json: any): Consultation {
    return ConsultationToJSONTyped(json, false);
}

export function ConsultationToJSONTyped(value?: Consultation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'entryStart': value['entryStart'],
        'isCreatedByService': value['isCreatedByService'],
        'isEditable': value['isEditable'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'id': UiIdentifierToJSON(value['id']),
        'healthPro': HealthProConsultationToJSON(value['healthPro']),
        'secondaryHealthPro': HealthProConsultationToJSON(value['secondaryHealthPro']),
        'instituteWithRole': InstituteWithRoleToJSON(value['instituteWithRole']),
        'conclusionGroups': ((value['conclusionGroups'] as Array<any>).map(ConclusionGroupFullToJSON)),
        'rows': value['rows'],
        'archivedByUser': HealthProConsultationToJSON(value['archivedByUser']),
        'archivedDate': value['archivedDate'],
    };
}

